// Plan Management participant statement — branded PDF (jsPDF + autotable + org letterhead).
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { renderPdfHeader, brandRgb } from './exportBranding';

const money = (n) => `$${Number(n || 0).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const MANAGED = { ndia_managed: 'NDIA-managed', plan_managed: 'Plan-managed', self_managed: 'Self-managed' };

export function generateStatementPdf(data, branding) {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pw = doc.internal.pageSize.getWidth();
  const name = `${data.client.first_name} ${data.client.last_name}`;
  const period = `${data.from || 'start'} → ${data.to || 'today'}`;
  let y = renderPdfHeader(doc, branding, { reportTitle: 'Plan Management Statement', subtitle: `${name}${data.client.ndis_number ? '  ·  NDIS ' + data.client.ndis_number : ''}  ·  ${period}` });

  // Plan budget summary
  (data.plans || []).forEach((p) => {
    doc.setFontSize(10); doc.setFont('helvetica', 'bold'); doc.setTextColor(30, 41, 59);
    doc.text(MANAGED[p.managed_by] || 'Plan', 14, y);
    doc.setFont('helvetica', 'normal'); doc.setTextColor(100, 116, 139);
    doc.text(`Budget ${money(p.budget)}   ·   Used ${money((Number(p.used_to_date) || 0) + (Number(p.pm_committed) || 0))}   ·   Remaining ${money(p.remaining)}`, 14, y + 4.5);
    y += 11;
  });
  y += 2;

  // Spend by category (CareView statement breakdown)
  if ((data.byCategory || []).length) {
    autoTable(doc, {
      startY: y,
      head: [['Spend by category', 'Amount']],
      body: data.byCategory.map((c) => [c.label, money(c.amount)]),
      styles: { fontSize: 9, cellPadding: 3 },
      headStyles: { fillColor: [(brandRgb(branding).r), (brandRgb(branding).g), (brandRgb(branding).b)], textColor: 255 },
      columnStyles: { 1: { halign: 'right' } },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 6;
  }

  autoTable(doc, {
    startY: y,
    head: [['Date', 'Provider', 'Invoice #', 'Status', 'Amount']],
    body: (data.invoices || []).map((i) => [
      (i.invoice_date || '').toString().slice(0, 10), i.provider_display || '', i.provider_invoice_number || '',
      String(i.status || '').replace(/_/g, ' '), money(i.total_amount),
    ]),
    foot: [[{ content: 'Total', colSpan: 4, styles: { halign: 'right', fontStyle: 'bold' } }, { content: money(data.total), styles: { fontStyle: 'bold' } }]],
    styles: { fontSize: 9, cellPadding: 3 },
    headStyles: { fillColor: [(brandRgb(branding).r), (brandRgb(branding).g), (brandRgb(branding).b)], textColor: 255 },
    columnStyles: { 4: { halign: 'right' } },
    didDrawPage: (d) => {
      doc.setFontSize(8); doc.setTextColor(148, 163, 184);
      doc.text(`Page ${d.pageNumber} of ${doc.internal.getNumberOfPages()}`, pw / 2, doc.internal.pageSize.getHeight() - 6, { align: 'center' });
    },
  });

  doc.save(`statement-${name.replace(/\s+/g, '-').toLowerCase()}-${(data.to || '').slice(0, 7)}.pdf`);
}
